import { Typography } from 'styles';
import { IClaimBillingHistory } from 'types/Claim';
import { useTranslation } from 'utils/translations';

type Props = {
	item: IClaimBillingHistory;
};

const BillingContent = ({ item }: Props) => {
	const { t: tClientLabels } = useTranslation('', {
		keyPrefix: 'clientLabels',
	});
	const { t: tDbLabels } = useTranslation('', {
		keyPrefix: 'dbLabels',
	});

	return (
		<Typography variant="body">
			{tClientLabels('claim.history.billingStatusChanged', {
				status: tDbLabels(item.label),
			})}
		</Typography>
	);
};

export default BillingContent;
